import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    if (id === "home") {
      if (window.lenis && typeof window.lenis.scrollTo === "function") {
        window.lenis.scrollTo(0);
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      return;
    }

    const element = document.getElementById(id);
    if (!element) return;

    if (window.lenis && typeof window.lenis.scrollTo === "function") {
      window.lenis.scrollTo(element);
    } else {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleNavClick = (event, targetId) => {
    event.preventDefault();

    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: targetId } });
    } else {
      scrollToSection(targetId);
    }

    setIsMenuOpen(false);
  };



  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-transparent">
      <div className="mx-6 my-1 flex justify-between items-center px-6 py-4 bg-black/30 text-white shadow-lg rounded-xl backdrop-blur-md sticky">
        {/* Logo/Name Section */}
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={(e) => handleNavClick(e, "home")}
        >
          <span className="text-2xl font-semibold text-gray-400">
            {"{"}
          </span>
          <span className="text-xl font-semibold text-white px-1">
            Ali Hassan
          </span>
          <span className="text-2xl font-semibold text-gray-400">
            {"}"}
          </span>
        </div>

        {/* Navigation Links */}
        <ul className="hidden md:flex gap-6 items-center text-lg font-medium">
          <li className="hover:text-blue-500 hover:scale-110 transition-all duration-300">
            <Link to="/" onClick={(e) => handleNavClick(e, "home")}>Home</Link>
          </li>
          <li className="hover:text-blue-500 hover:scale-110 transition-all duration-300">
            <Link to="/" onClick={(e) => handleNavClick(e, "portfolio")}>Portfolio</Link>
          </li>
          <li className="hover:text-blue-500 hover:scale-110 transition-all duration-300">
            <Link to="/" onClick={(e) => handleNavClick(e, "skill")}>Skill</Link>
          </li>
          <li className="hover:text-blue-500 hover:scale-110 transition-all duration-300">
            <Link to="/" onClick={(e) => handleNavClick(e, "about")}>About</Link>
          </li>
          <li className="hover:text-blue-500 hover:scale-110 transition-all duration-300">
            <Link to="/" onClick={(e) => handleNavClick(e, "services")}>Services</Link>
          </li>
          <li className="hover:text-blue-500 hover:scale-110 transition-all duration-300">
            <Link to="/" onClick={(e) => handleNavClick(e, "contact")}>Contact</Link>
          </li>
        </ul>



        {/* Mobile Menu Button */}
        <div
          className="md:hidden text-3xl cursor-pointer text-white ml-4"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <div className="space-y-2">
              <div className="w-6 h-0.5 bg-white rotate-45 translate-y-1.5"></div>
              <div className="w-6 h-0.5 bg-white -rotate-45"></div>
            </div>
          ) : (
            <div className="space-y-2">
              <div className="w-6 h-0.5 bg-white"></div>
              <div className="w-6 h-0.5 bg-white"></div>
              <div className="w-6 h-0.5 bg-white"></div>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden flex flex-col items-center gap-4 py-4 text-lg font-medium bg-black/30 mx-6 rounded-xl backdrop-blur-md text-white">
          <Link
            to="/"
            className="hover:text-blue-500 transition duration-300 w-full text-center py-2"
            onClick={(e) => handleNavClick(e, "home")}
          >
            Home
          </Link>
          <Link
            to="/"
            className="hover:text-blue-500 transition duration-300 w-full text-center py-2"
            onClick={(e) => handleNavClick(e, "portfolio")}
          >
            Portfolio
          </Link>
          <Link
            to="/"
            className="hover:text-blue-500 transition duration-300 w-full text-center py-2"
            onClick={(e) => handleNavClick(e, "skill")}
          >
            Skill
          </Link>
          <Link
            to="/"
            className="hover:text-blue-500 transition duration-300 w-full text-center py-2"
            onClick={(e) => handleNavClick(e, "about")}
          >
            About
          </Link>
          <Link
            to="/"
            className="hover:text-blue-500 transition duration-300 w-full text-center py-2"
            onClick={(e) => handleNavClick(e, "services")}
          >
            Services
          </Link>
          <Link
            to="/"
            className="hover:text-blue-500 transition duration-300 w-full text-center py-2"
            onClick={(e) => handleNavClick(e, "contact")}
          >
            Contact
          </Link>
        </div>
      )}
    </div>
  );
}

export default Navbar;